/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Which jobs a job-mapping read covers. "profile" (the default) returns every mapping row of the replacement — what the Profile Mapping screen maps once for all surveys. "targetSurvey" narrows to the jobs that belong to the survey being replaced, which is what the wizard's Job Mappings step shows.
 */
export enum SurveyReplacementJobMappingScope {
    PROFILE = 'profile',
    TARGET_SURVEY = 'targetSurvey',
}
